<template>
  <ul class="media-grid" :style="gridStyle">
    <slot></slot>
  </ul>
</template>

<script setup>
import { computed } from 'vue';

/*
 * A uniform grid. The gallery previously sized tiles by fixed pixel heights
 * (250/200/180/280 across breakpoints) inside fluid columns, so the aspect
 * ratio changed continuously with the viewport and object-fit cropped
 * arbitrarily. Ratio is fixed here and the column count is fluid.
 */
const props = defineProps({
  min: { type: String, default: '15rem' },
});

const gridStyle = computed(() => ({
  gridTemplateColumns: `repeat(auto-fill, minmax(min(${props.min}, 100%), 1fr))`,
}));
</script>

<style scoped>
.media-grid {
  display: grid;
  gap: var(--space-4);
  list-style: none;
  margin: 0;
  padding: 0;
}

.media-grid :deep(li) {
  margin: 0;
}
</style>
